import { computed, toValue, type MaybeRefOrGetter } from 'vue'

import { useQuery } from '@tanstack/vue-query'

import { CurrentUserService } from '@common/current-user-layer/services/currentUser.service'

export const useAccountSettingsTabVisibilityQueryStore = () => {
  const queryKeys = {
    isGroupAdminOrOwner: (contactId: string) => ['account-settings', 'tab-visibility', 'is-group-admin-or-owner', contactId] as const,
  }

  const fetchIsGroupAdminOrOwnerQuery = (contactId: MaybeRefOrGetter<string | null | undefined>) => {
    return useQuery({
      queryKey: computed(() =>
        toValue(contactId)
          ? [...queryKeys.isGroupAdminOrOwner(toValue(contactId)!)]
          : (['account-settings', 'tab-visibility', 'is-group-admin-or-owner', 'none'] as const)
      ),
      queryFn: async (): Promise<boolean> => {
        const id = toValue(contactId)
        if (!id) {
          return false
        }
        const service = new CurrentUserService()
        return service.fetchIsContactAdminOrOwnerOfAnyGroup(id)
      },
      enabled: computed(() => Boolean(toValue(contactId))),
      staleTime: 5 * 60 * 1000,
    })
  }

  return {
    fetchIsGroupAdminOrOwnerQuery,
  }
}
